import React from "react"
import { Link, graphql, useStaticQuery} from 'gatsby'
//import { css } from "@emotion/core"
import Img from 'gatsby-image'

import Layout from '../components/layout'
import '../styles/index.scss'
import portfolioStyles from '../styles/portfolio.module.scss'
import headerStyles from '../styles/header.module.scss'
import Metatags from '../components/metatag';

import { IoIosArrowRoundDown } from "react-icons/io";

import socialCard from '../images/card.jpg'


const Portfolio = () => {
    
    const data = useStaticQuery(graphql`
    
        query {
            allContentfulPortfolio ( sort: { fields: date, order: DESC }) {
                edges {
                    node{
                        projectTitle
                        slug
                        typeOfProject
                        subtituloProyecto
                        date(formatString:"MMMM Do, YYYY")
                        heroImage {
                            fluid(maxWidth: 300) {
                              src
                            }
                        }
                    }
                }
            }

            site{
                siteMetadata{
                    title
                    description
                    siteUrl
                }
            }
            image2: file (relativePath: {eq: "portfolio.png"}){
                id
                childImageSharp{
                  fixed{
                    ...GatsbyImageSharpFixed
                  }
                  fluid{
                    ...GatsbyImageSharpFluid
                  }
                }
            }
        }
    
    `)


    return(
        <Layout>
            <Metatags
                title={`${data.site.siteMetadata.title} | Portfolio`}
                description={data.site.siteMetadata.description}
                thumbnail={`${data.site.siteMetadata.siteUrl}${socialCard}`}
                url= {data.site.siteMetadata.siteUrl}
            />
            <section className={headerStyles.header_wrapper}>

                <div className={headerStyles.header_wrapper_left}>
                    <h1 className={headerStyles.header_wrapper_title}>Portfolio páginas web</h1>
                    <h2 className={headerStyles.header_wrapper_main}>Portfolio, echa un vistazo a mi <span className={headerStyles.header_wrapper_main_highlight}> trabajo</span>
                    </h2>
                    <Link to='/portfolio#projects' className="btn btn__white btn__animated">Ver Portfolio</Link>
                </div>

                <div className={headerStyles.header_wrapper_right}>
                    <Img fluid={data.image2.childImageSharp.fluid} alt="Diseño web sevilla"/>
                    
                </div>

            </section>
            <IoIosArrowRoundDown className={headerStyles.header_arrow} />

            <section className={portfolioStyles.projects} id='projects'>

                <div className={portfolioStyles.projects_header}>
                    <h4>casos de éxito</h4>
                    <h2 className={headerStyles.header_titles_second_text}>Últimos trabajos</h2>
                </div>
                
                    <div className={portfolioStyles.projects_wrapper}>

                    {data.allContentfulPortfolio.edges.map((edge) => {
                                return (
                                    <Link to={`/portfolio/${edge.node.slug}`} className={portfolioStyles.projects_wrapper_card_link} >
                                            <div className={portfolioStyles.projects_wrapper_card}>

                                                <h4 className={portfolioStyles.projects_wrapper_card_title}>{edge.node.typeOfProject}</h4>
                                                
                                                <img className={portfolioStyles.projects_wrapper_card_img} src={edge.node.heroImage.fluid.src} alt={edge.node.subtituloProyecto}/>
                                           

                                                <h2 className={headerStyles.header_titles_text_700}>{edge.node.projectTitle}</h2>
                                                <p>{edge.node.subtituloProyecto}</p>
                                            
                                                <IoIosArrowRoundDown className={portfolioStyles.projects_wrapper_card_arrow} />

                                                <span className={portfolioStyles.projects_wrapper_card_view}>Ver Proyecto</span>

                                            </div>
                                    </Link>


                                   
                                )
                    })}
                        
                        
                        

                    </div>

            </section>
            
        </Layout>
    )

}

export default Portfolio
